import { connect } from 'react-redux';
import Management, {
  ManagementProps,
} from '@/pages/CompanyReport/components/Management';
import getManagementSelector from '@/pages/CompanyReport/components/Management/redux/selectors';
import { getViewMode } from '@ducks/location/selectors';
import { getAnalysis } from '@/pages/CompanyReport/redux/selectors';
const mapStateToProps = (state, ownProps): ManagementProps => {
  const management = getManagementSelector(state, ownProps);
  const viewMode = getViewMode(state);
  const analysis = getAnalysis(state, ownProps);

  return {
    keyMetric: management.keyMetric,
    keyMetricTitle: management.keyMetricTitle,
    board: management.board,
    boardAge: management.boardAge,
    companyId: management.companyId,
    leaderAge: management.leaderAge,
    hasCEO: management.hasCEO,
    companyName: management.companyName,
    currencyISO: management.currencyISO,
    boardTenure: management.boardTenure,
    uniqueSymbol: management.uniqueSymbol,
    reportingUnit: management.reportingUnit,
    leaderTenure: management.leaderTenure,
    leaderTenureFormatted: management.leaderTenureFormatted,
    managementAge: management.managementAge,
    currencySymbol: management.currencySymbol,
    leaderYearBorn: management.leaderYearBorn,
    leaderLastName: management.leaderLastName,
    managementTeam: management.managementTeam,
    leaderBiography: management.leaderBiography,
    managementTenure: management.managementTenure,
    leaderSalutation: management.leaderSalutation,
    leaderCompensation: management.leaderCompensation,
    statements: management.statements,
    sectionNumber: ownProps.sectionNumber,
    viewMode,
    marketCapListing: analysis.marketCapRawData.listing,
    /**
     * CEO Compensation
     */
    earnings: management.earnings,
    earningsMax: management.earningsMax,
    earningsMin: management.earningsMin,
    salary: management.salary,
    totalCompensation: management.totalCompensation,
    salaryMax: management.salaryMax,
    salaryMin: management.salaryMin,
    totalCompensationMax: management.totalCompensationMax,
    totalCompensationMin: management.totalCompensationMin,
    CEOCompensationDayZero: management.CEOCompensationDayZero,
  };
};

export default connect<ManagementProps, undefined, Partial<ManagementProps>>(
  mapStateToProps
)(Management);
